import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import mapValues from 'lodash/mapValues';
import { useTranslation } from 'react-i18next';

const useTranslatedValidation = (observedStep) => {
	const [translatedValidation, setTranslatedValidation] = useState({});
	const validation = useSelector((state) => state.formValidation[observedStep]);
	const [t] = useTranslation();
	const user = useSelector((state) => state.settings.currentUser);
	const language = useSelector((state) => state.settings.language);
	useEffect(() => {
		if (!validation) {
			return;
		}
		setTranslatedValidation(
			mapValues(validation, (value) => {
				return t('validation.' + value);
			})
		);
	}, [validation, user, language]);
	return translatedValidation;
};

export default useTranslatedValidation;
